"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { Link } from "capitalrx-components-2.0/lib/general";
import classNames from "classnames";
import styles from "./Error404Page.module.css";
import { useModulePathResolver } from "./hooks";
export const Error404Page = (props) => {
  const { className } = props;
  const modulePath = useModulePathResolver();
  return /* @__PURE__ */ jsx("div", { className: classNames(styles.root, "pageNotFound", className), children: /* @__PURE__ */ jsxs("div", { className: classNames(styles.content, "errBlock"), children: [
    /* @__PURE__ */ jsx("h1", { className: classNames(styles.title, "errCode"), children: "404 - Page Not Found" }),
    /* @__PURE__ */ jsxs("p", { className: classNames(styles.message, "errMsg"), children: [
      "We couldn\u2019t find the page you\u2019re looking for.",
      /* @__PURE__ */ jsx("br", {}),
      "The page may have been moved, deleted, or the URL may be incorrect."
    ] }),
    /* @__PURE__ */ jsxs("p", { className: styles.message, children: [
      "Check the URL for errors or return to the ",
      /* @__PURE__ */ jsx(Link, { to: modulePath("/"), children: "homepage" })
    ] })
  ] }) });
};
